import { getRichTextPlainText } from './getRichTextPlainText';

// Flattens a value into plain text for use in analytics payloads.
// Accepts a plain string, a React node (e.g. hand-written JSX), or a CMS
// <RichText> element — passing a React element straight into an event
// payload breaks serialization (it carries a circular _owner reference).
//
// A CMS-driven rich-text value arrives as a <RichText content={...} />
// element (see cms/schemas.js's inlineRichTextFromCMSSchema) whose actual
// text lives in the Storyblok document under props.content, not
// props.children, so that case is delegated to getRichTextPlainText.
// Matched by displayName rather than importing RichText itself, since
// cms -> CMSBlok -> (various CMS-block components) can loop back through
// whichever component is consuming this helper.
export const getPlainText = node => {
  if (node == null || typeof node === 'boolean') {
    return '';
  }
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }
  if (Array.isArray(node)) {
    return node.map(getPlainText).join('');
  }
  if (typeof node === 'object') {
    if (node.type?.displayName === 'RichText') {
      return getRichTextPlainText(node.props.content);
    }
    if (node.props) {
      return getPlainText(node.props.children);
    }
  }
  return '';
};
